
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcChartObjectVesselButton as ObcChartObjectVesselButtonElement} from '@oicl/openbridge-webcomponents/dist/ar/chart-object-vessel-button/chart-object-vessel-button.js';
 
 
 

 
 export const ObcChartObjectVesselButton = createComponent({
   react: React,
   tagName: 'obc-chart-object-vessel-button',
   elementClass: ObcChartObjectVesselButtonElement,
   events: {
     
   }
  });
 
 